import {
	post,
} from './utilities/provider';
import type { AxiosRequestConfig } from 'axios';
import {
	type ApiV1,
} from '@teamworksdev/influencer/core';

const RESOURCE = 'payments';

export function useExchangePaymentsService(config?: Omit<AxiosRequestConfig, 'key'>) {
	const getExchangePaymentsOnboardingStatus = async (users: ApiV1.GetPaymentsOnboardingStatusParams) => {
		const response = await post<ApiV1.GetPaymentsOnboardingStatusResponse>(`${RESOURCE}/onboarding-status`, {
			key: 'getExchangePaymentMethods',
			...config,
			...users,
		});
		return response.data.data;
	};
	return {
		getExchangePaymentsOnboardingStatus,
	};
}
